import AuthService from '../services/auth/AuthService';
import { UserContextService } from '../services/http';
import { AppSettings } from './models';
import axios from 'axios';
import { HttpHandler } from './http/HttpHandler';
import IUserContextService from '@/services/http/interfaces/IUserContextService';
import { ErrorHelper } from './helpers';
import IAdminService from '@/services/http/interfaces/IAdminService';
import { AdminService } from '@/services/http/AdminService';

export default class Factory {
  private appSettings: AppSettings;
  private httpClient: any;

  constructor(config: AppSettings) {
    this.appSettings = config;

    // setup http client
    this._setupHttpClient();
  }

  createAuthService(): AuthService {
    return new AuthService(this.appSettings.auth);
  }

  createUserContextService(): IUserContextService {
    return new UserContextService(new HttpHandler(this.httpClient));
  }

  createAdminService(): IAdminService {
    return new AdminService(new HttpHandler(this.httpClient));
  }

  private _setupHttpClient() {
    this.httpClient = this._createHttpClient();

    // auth service
    const authService = this.createAuthService();

    // Add a request interceptor
    this.httpClient.interceptors.request.use(async (request: any) => {
      // refresh api access token if expired. Expiry is being checked in method itself.
      const updatedAccessToken = await authService.getAccessToken();
      if (updatedAccessToken) {
        request.headers.authorization = `Bearer ${updatedAccessToken}`;
      }
      return Promise.resolve(request);
    });

    this.httpClient.interceptors.response.use(
      (response: any) => response,
      (error: any) => {
        if (error.response) {
          return Promise.reject(ErrorHelper.getHttpErrors(error));
        }
      });

  }

  private _createHttpClient(): any {
    return axios.create({
      baseURL: this.appSettings.apiUrl,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }
}
